import { render, staticRenderFns } from "./heizwert-pellets.vue?vue&type=template&id=a2af6bfe&scoped=true"
import script from "./heizwert-pellets.vue?vue&type=script&lang=ts"
export * from "./heizwert-pellets.vue?vue&type=script&lang=ts"
import style0 from "./heizwert-pellets.vue?vue&type=style&index=0&id=a2af6bfe&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2af6bfe",
  null
  
)

export default component.exports